import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import getItemStyles from '../../../utils/item-styles.js';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments.js';

/**
 * Returns a formatted day off item for the seven to nine day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTime = (resource, dayType, dayOffStartTime) => {
  const { rId } = resource;
  const { rdtId } = dayType;
  if(dayType === undefined){
    return 'Insert a properDayOff format'
  }
  const { dorId, abbreviation, dayTypeComment, myDayTypeComment, isApproved, wbse, showCostObjectId, costCenter } = dayType.dayOff;
  let hasComment = false;
  if ( ignoreDummyComments(dayTypeComment || myDayTypeComment) ) {
    hasComment = true;
  }

  const offTimeStyle = getItemStyles('offtime');
  const offTime = {
    id: rdtId === undefined ? dayType.rdtId : rdtId,
    itemType: 'off-time',
    group: rId,
    dorId,
    title: abbreviation === undefined ? dayType.dayOff.title : abbreviation,
    abbreviation,
    start_time: dayjs(dayOffStartTime).startOf('day'),
    end_time: dayjs(dayOffStartTime).endOf('day'),
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: dayType.dayOff.isApproved ? "gray" : offTimeStyle.backgroundColor,
    color: offTimeStyle.color,
    borderStyle: offTimeStyle.borderStyle,
    borderColor: hasComment ? "red" : offTimeStyle.borderColor, isApproved,
    isApproved,
    wbse,
    showCostObjectId,
    costCenter
  };

  if(dayType.dayOff.comment){
    const offTimeComment = {
      ... offTime,
      comment: dayType.dayOff.comment
    }
    return offTimeComment
  }

  return offTime;
}

export default generateOffTime;
